import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { getPropByName } from '../../../../utils/props';
import { selectWorks } from '../../../Api/selectors';
import { fetchCompany } from '../../../Companies/actions';
import { REQUEST_COMPANY } from '../../../Companies/constants';
import { selectCompany } from '../../../Companies/selectors';
import { selectNewOrderValue, selectNewVehicleValue } from '../../selectors';
import { selectNewInvoiceValue } from '../../../Invoices/selectors';

import styles from './CompanyUsersSearchSelect.module.css';

import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { SearchSelect } from '../../../../components/SearchSelectComponent';
import { selectHomeUsers, selectUser } from '../../../Users/selectors';
import LoadingField from '../../../../containers/App/Components/LoadingField/LoadingField';
import { REQUEST_HOME_COMPANY_USERS } from '../../../Users/constants';
import { fetchHomeCompanyUsers } from '../../../Users/actions';

const Wrapper = styled.div`
  width: 100%;
`;

const STATE = {
  active: false,
  companyId: null,
  selectedUser: null,
};

/* eslint-disable react/prefer-stateless-function */
class CompanyUsersSearchSelectComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetchUsers();
  }

  reset() {
    this.setState({ ...STATE });
  }

  static getDerivedStateFromProps(props, state) {
    let newState = { ...state };
    if (props.companyId != state.companyId) {
      props.fetch(props.companyId);
      newState.companyId = props.companyId;
    }
    return newState;
  }

  applySelection() {
    this.props.onChange(this.state.selectedUser?.id);
    this.reset();
  }

  get usersOptions() {
    const users = this.props.homeUsers;
    const defaultValue = this.props.companyDetails ? {} : this.props.defaultValue;

    let userOptions = [];
    [...users, defaultValue ?? {}]?.forEach(u => {
      if (u?.id) {
        userOptions.push({
          value: u?.id,
          label: `${getPropByName(u, 'name') ?? ''} ${getPropByName(u, 'surname') ?? ''}`,
        });
      }
    });
    return userOptions;
  }

  get userId() {
    if (this.props.order) {
      return this.props.editedValue || this.props.orderValue;
    }
    return this.props.selectedCreditorId ? this.props.selectedCreditorId : this.props.value;
  }

  get value() {
    return this.usersOptions?.find(u => u?.value === this.userId);
  }

  render() {
    if (this.props.work) return <LoadingField />;

    return (
      <div>
        <div className={styles.container}>
          <OverlayTrigger
            placement="right"
            overlay={
              this.props.disabled ||
              (!this.props.companyId && !this.props.homeUsers?.length) ||
              (this.props.financialContact && this.props.includeFinancialContact !== '1') ? (
                <Tooltip className={styles.tooltip} id="tooltip-disabled">
                  {this.lbl(`add a customer`)}
                </Tooltip>
              ) : (
                <Tooltip className={styles.tooltip2} id="tooltip-disabled"></Tooltip>
              )
            }
          >
            <Wrapper>
              <SearchSelect
                id="tooltip-disabled"
                options={this.usersOptions}
                value={this.value}
                onChange={evt => {
                  const userId = evt.value;
                  this.props.onChange(userId);
                  this.reset();
                }}
                disabled={
                  this.props.disabled ||
                  (!this.props.companyId && !this.props.homeUsers?.length) ||
                  (this.props.financialContact && this.props.includeFinancialContact !== '1')
                }
              />
            </Wrapper>
          </OverlayTrigger>
        </div>
      </div>
    );
  }
}

CompanyUsersSearchSelectComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    company: selectCompany(ownProps.companyId),
    homeUsers: selectHomeUsers(),
    value: selectNewVehicleValue(ownProps.type),
    orderValue: ownProps.invoicePage ? selectNewInvoiceValue(ownProps.type) : selectNewOrderValue(ownProps.type),
    work: selectWorks([REQUEST_COMPANY, REQUEST_HOME_COMPANY_USERS]),
    defaultValue: selectUser(ownProps?.userValue),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(companyId) {
      dispatch(fetchCompany(companyId));
    },
    fetchUsers(callback) {
      dispatch(fetchHomeCompanyUsers(callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyUsersSearchSelect = compose(withConnect, withRouter)(CompanyUsersSearchSelectComp);
